export default {"src":"/_next/static/media/docs.006a0f98.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};